module.exports = __webpack_public_path__ + "img/diamond.1472b3c6.svg";